import { put, call, takeEvery, select } from 'redux-saga/effects';

import { getInventoryFeatureFlag } from '../../api/inventory/inventoryFeatureFlag';
import isFeatureEnabled from '../../selectors/isFeatureEnabled';
import {
  GET_INVENTORY_FEATURE_FLAG,
  HANDLE_ACCESS_BUSINESS_LIBRARY,
} from './types';
import { setInvetoryFeatures } from './actions';

const BUSINESS_LIBRARY_MENU = 'business-library-menu';

function* getInventoryFeature() {
  try {
    const response = yield call(getInventoryFeatureFlag);
    return response.data.map((feature) => {
      if (feature.name === 'CONTROL_PANEL_FEATURE') {
        feature.name = BUSINESS_LIBRARY_MENU;
      }
      return feature.name;
    });
  } catch (err) {
    // avoid an error
    return [];
  }
}

function* inventoryFeatureFlagToggle() {
  try {
    const features = yield call(getInventoryFeature);
    yield put(setInvetoryFeatures(features));
  } catch (err) {
    yield put(setInvetoryFeatures([]));
  }
}

function* handleAccessBusinessMenu() {
  const features = yield call(getInventoryFeature);
  const isEnabled = yield select(isFeatureEnabled, BUSINESS_LIBRARY_MENU);
  const isEnableBusinessLib = features.includes(BUSINESS_LIBRARY_MENU);

  if (!isEnabled || !isEnableBusinessLib) {
    window.location.replace('/dashboard');
  }
}

export default function* saga() {
  yield takeEvery(GET_INVENTORY_FEATURE_FLAG, inventoryFeatureFlagToggle);
  yield takeEvery(HANDLE_ACCESS_BUSINESS_LIBRARY, handleAccessBusinessMenu);
}
